function AwsChallengeScript() {
  return (
    <script
      type="text/javascript"
      src="https://8b27595d7cf0.eu-west-1.sdk.awswaf.com/8b27595d7cf0/ee498a860138/challenge.js"
      defer
    ></script>
  );
}

export default AwsChallengeScript;
